var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 418.645,
    height: 414.346,
    viewBox: "0 0 418.645 414.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 147 248"
  }, /*#__PURE__*/React.createElement("image", {
    width: 147,
    height: 248,
    xlinkHref: "data:image/png;base64,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"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Press_pause-amico",
    "data-name": "Press pause-amico",
    transform: "translate(-14.053 -65.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68001",
    "data-name": "Path 68001",
    d: "M381.134,252.319c-82.005-47.306-214.526-47.306-296,0s-81,124.117,1.039,171.459,214.526,47.352,296,0S463.177,299.671,381.134,252.319Z",
    transform: "translate(-10.277 20.314)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-125",
    d: "M131,454,53.75,409.81a1.24,1.24,0,0,1,0-2.35l246-142a4.51,4.51,0,0,1,4.08,0L381,309.6a1.24,1.24,0,0,1,0,2.35l-246,142a4.49,4.49,0,0,1-4,.05Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-125-2",
    "data-name": "freepik--shadow--inject-125",
    d: "M225.13,266.2c-9,5.17-9,13.55,0,18.73s23.48,5.17,32.44,0,9-13.56,0-18.73S234.09,261,225.13,266.2Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-125-2",
    "data-name": "freepik--device--inject-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Case--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67954",
    "data-name": "Path 67954",
    d: "M300.8,275.63l4.47-2.58s23.74-77.47,26-82-1.78-6.78-6.06-4.31L102.25,315.31c-4.28,2.47-5.63,5.86-9.43,13.25s-25.25,78.57-25.25,78.57a4,4,0,0,0,1.91,4.18l50.76,29.4L353.4,306.1Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67955",
    "data-name": "Path 67955",
    d: "M300.8,275.63l4.47-2.58s23.74-77.47,26-82-1.78-6.78-6.06-4.31L102.25,315.31c-4.28,2.47-5.63,5.86-9.43,13.25s-25.25,78.57-25.25,78.57a4,4,0,0,0,1.91,4.18l50.76,29.4L353.4,306.1Z",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67956",
    "data-name": "Path 67956",
    d: "M95.62,330.35c-2.89,5.6-25.22,78.3-25.22,78.3L308.09,271.42s23.57-73.89,25.93-78.54-1.78-6.78-6.06-4.32L105,317.1C100.77,319.57,98.51,324.75,95.62,330.35Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67957",
    "data-name": "Path 67957",
    d: "M95.62,330.35c-2.89,5.6-25.22,78.3-25.22,78.3L308.09,271.42s23.57-73.89,25.93-78.54-1.78-6.78-6.06-4.32L105,317.1C100.77,319.57,98.51,324.75,95.62,330.35Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67958",
    "data-name": "Path 67958",
    d: "M303.56,274.04,70.4,408.65l51.63,29.81L355.2,303.86Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67959",
    "data-name": "Path 67959",
    d: "M319.8,104.27,95.16,233.72c-4.93,2.85-6.46,7.45-5.59,13.52L116.15,433.8c.87,6.07,5.7,9.61,10.62,6.77L349.42,312.08c4.93-2.85,8.22-10.07,7.35-16.13L330.29,110.1C329.42,104,324.72,101.42,319.8,104.27Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67960",
    "data-name": "Path 67960",
    d: "M319.8,104.27,95.16,233.72c-4.93,2.85-6.46,7.45-5.59,13.52L116.15,433.8c.87,6.07,5.7,9.61,10.62,6.77L349.42,312.08c4.93-2.85,8.22-10.07,7.35-16.13L330.29,110.1C329.42,104,324.72,101.42,319.8,104.27Z",
    fill: "#fff",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67961",
    "data-name": "Path 67961",
    d: "M334.94,108.23a6.94,6.94,0,0,0-6.06.75L106.23,237.48a14.89,14.89,0,0,0-5.68,6.52l-7.19-3c1.58-3.45,4.33-4.7,6.69-6.08l222.64-128.5a6.88,6.88,0,0,1,6.29-.65h0Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67962",
    "data-name": "Path 67962",
    d: "M123.37,442.45h0c-2.21-.91-3.85-3.2-4.33-6.54L92.7,251c-.54-3.79-.72-7.19.66-10.05l7.19,3.05c-.19.39-.37.8-.54,1.21a9.4,9.4,0,0,0-.35,1,1,1,0,0,0,0,.16,11.773,11.773,0,0,0-.33,1.16c-.11.4-.2.82-.27,1.22s-.1.61-.13.92a14.85,14.85,0,0,0,0,3.94l26.48,185.84c.48,3.37,2.15,5.68,4.38,6.58Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67963",
    "data-name": "Path 67963",
    d: "M328.88,109,104.24,238.45c-4.92,2.84-6.46,7.45-5.59,13.51l26.71,187.5c.87,6.07,5.57,8.68,10.49,5.83L358.5,316.8c4.93-2.84,8.22-10.06,7.35-16.13L339.37,114.82C338.5,108.76,333.8,106.15,328.88,109Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67964",
    "data-name": "Path 67964",
    d: "M344.83,316,146.09,430.63c-2.55,1.48-5,.12-5.43-3L114.44,243.69a8.86,8.86,0,0,1,3.81-8.36L317,120.64c2.55-1.47,5-.12,5.43,3l26.22,183.92a8.87,8.87,0,0,1-3.82,8.44Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67965",
    "data-name": "Path 67965",
    d: "M114.44,243.69l26.22,183.92a.648.648,0,0,0,.07.36L339.46,313.29a8.85,8.85,0,0,0,3.81-8.36L317,120.64,118.25,235.33a8.86,8.86,0,0,0-3.81,8.36Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67966",
    "data-name": "Path 67966",
    d: "M124.58,357.58a4.43,4.43,0,0,1-1.92,4.2c-1.28.74-2.51.06-2.73-1.52a4.47,4.47,0,0,1,1.91-4.21C123.13,355.31,124.35,356,124.58,357.58Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67967",
    "data-name": "Path 67967",
    d: "M115.89,314.51h0a3.45,3.45,0,0,0-1.49,3.27l4.34,30.28c.18,1.23,1.13,1.76,2.13,1.18h0a3.47,3.47,0,0,0,1.49-3.27L118,315.69C117.84,314.46,116.89,313.93,115.89,314.51Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65736",
    "data-name": "Group 65736",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67968",
    "data-name": "Path 67968",
    d: "M145.22,412.73l-5.33-37.21,41.93-108.06,80,34.11-12.89-14.91,36.58-50.69,44.52,20.37,6.58,45.91Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67969",
    "data-name": "Path 67969",
    d: "M256.46,222.51c1.05,7.31,6.06,10.82,11.19,7.86s8.45-11.29,7.41-18.59S269,201,263.86,203.92,255.41,215.21,256.46,222.51Z",
    fill: "#3d4b54"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--video-window--inject-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bar--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67979",
    "data-name": "Path 67979",
    d: "M371.05,251.45l-1.76-12.34L161.07,359.33l1.7,11.91c.28,1.94,2.9,3.06,4.72,2L367.68,258A7.08,7.08,0,0,0,371.05,251.45Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67980",
    "data-name": "Path 67980",
    d: "M163.1,372.13a2.42,2.42,0,0,1-.33-.89l-1.7-11.91-5.87-2.52L156.79,368a5.233,5.233,0,0,0,.12.54,4.54,4.54,0,0,0,2.65,2.75l4.83,2.06.17.07a3.26,3.26,0,0,1-1.46-1.29Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67981",
    "data-name": "Path 67981",
    d: "M163.1,372.13a2.42,2.42,0,0,1-.33-.89l-1.7-11.91-5.87-2.52L156.79,368a5.233,5.233,0,0,0,.12.54,4.54,4.54,0,0,0,2.65,2.75l4.83,2.06.17.07a3.26,3.26,0,0,1-1.46-1.29Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67982",
    "data-name": "Path 67982",
    d: "M190.15,353.5l-.67-4.66c0-.33.16-.7.39-.71l4.78-.24c.32,0,.4.58.13.9l-4.11,4.9C190.47,353.93,190.2,353.83,190.15,353.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67983",
    "data-name": "Path 67983",
    d: "M200.5,347.52l-.67-4.66c-.05-.33.16-.7.39-.71l4.78-.23c.32,0,.4.57.13.9L201,347.71C200.81,348,200.55,347.86,200.5,347.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67984",
    "data-name": "Path 67984",
    d: "M206,344.85h0a.258.258,0,0,1-.4-.22l-.69-4.78a.66.66,0,0,1,.28-.62h0a.262.262,0,0,1,.4.23l.69,4.78A.67.67,0,0,1,206,344.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67985",
    "data-name": "Path 67985",
    d: "M174.57,362.49l-.66-4.66a.28.28,0,0,0-.52-.18l-4.11,4.89c-.27.32-.19.92.13.9l4.77-.23C174.42,363.19,174.62,362.83,174.57,362.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67986",
    "data-name": "Path 67986",
    d: "M169.18,366.12h0a.62.62,0,0,0,.28-.61l-.68-4.78a.26.26,0,0,0-.4-.23h0a.66.66,0,0,0-.28.62l.68,4.78C168.82,366.13,169,366.23,169.18,366.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67987",
    "data-name": "Path 67987",
    d: "M347.64,264.31a.59.59,0,0,1-.23,0,.44.44,0,0,1-.27-.33l-.81-5.64a.33.33,0,0,1,.18-.34l8.11-4.68a.48.48,0,0,1,.44,0,.41.41,0,0,1,.27.32l.81,5.64a.35.35,0,0,1-.18.35l-8.11,4.68a.47.47,0,0,1-.21,0Zm-.39-5.83.69,4.76,7.28-4.2-.69-4.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67988",
    "data-name": "Path 67988",
    d: "M360,253.33a.48.48,0,0,1-.5-.37l-.32-2.26a.34.34,0,0,1,.17-.34l2-1.14a.52.52,0,0,1,.63.12.34.34,0,0,1-.09.53l-1.76,1,.3,2.05a.38.38,0,0,1-.43.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67989",
    "data-name": "Path 67989",
    d: "M365.34,250.24a.47.47,0,0,1-.5-.36l-.23-1.6-1.34.77a.52.52,0,0,1-.63-.11.34.34,0,0,1,.08-.53l2-1.14a.52.52,0,0,1,.44,0,.42.42,0,0,1,.27.33l.33,2.26a.37.37,0,0,1-.42.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67990",
    "data-name": "Path 67990",
    d: "M364,255.65a.51.51,0,0,1-.42-.17.34.34,0,0,1,.09-.53l1.76-1-.3-2a.38.38,0,0,1,.4-.4.47.47,0,0,1,.5.37l.32,2.26a.34.34,0,0,1-.17.34l-2,1.13A.39.39,0,0,1,364,255.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67991",
    "data-name": "Path 67991",
    d: "M360.61,257.61a.59.59,0,0,1-.23-.05.4.4,0,0,1-.27-.32l-.33-2.26a.39.39,0,0,1,.39-.41.48.48,0,0,1,.5.37l.23,1.6,1.34-.77a.51.51,0,0,1,.63.11.34.34,0,0,1-.08.53l-2,1.14a.727.727,0,0,1-.18.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67992",
    "data-name": "Path 67992",
    d: "M335.91,268.32l.81-.35a.09.09,0,0,1,.12,0,2.27,2.27,0,0,0,.29.48v.23l-.35.94v.21l.75.42a.176.176,0,0,0,.15-.13l.47-.87c.05-.09.12-.15.17-.15a1.491,1.491,0,0,0,.51,0,.1.1,0,0,1,.11.08l.23.93a.08.08,0,0,0,.12.05l.86-.5a.23.23,0,0,0,.09-.18l-.05-1a.31.31,0,0,1,.09-.23,3.413,3.413,0,0,0,.39-.45c0-.07.12-.12.16-.11l.73.26a.394.394,0,0,0,.15-.14l.46-1v-.21l-.62-.49a.3.3,0,0,1,0-.22,4.314,4.314,0,0,0,.1-.61.33.33,0,0,1,.11-.22l.75-.55a.18.18,0,0,0,.08-.18l-.15-1.07a.08.08,0,0,0-.11-.07l-.8.35a.1.1,0,0,1-.13-.05,2.751,2.751,0,0,0-.28-.48.26.26,0,0,1,0-.23l.35-.94v-.21l-.75-.42a.176.176,0,0,0-.15.13l-.48.87c-.05.09-.12.15-.16.15a2.3,2.3,0,0,0-.52,0,.115.115,0,0,1-.11-.08l-.22-.93a.08.08,0,0,0-.12-.05l-.87.5a.19.19,0,0,0-.08.18l.05,1a.37.37,0,0,1-.1.23,5.626,5.626,0,0,0-.38.45c-.06.07-.13.12-.17.11l-.73-.26a.333.333,0,0,0-.14.14l-.46,1c0,.09-.05.19,0,.21l.63.5v.21a4.28,4.28,0,0,0-.09.61.38.38,0,0,1-.11.22l-.76.55a.21.21,0,0,0-.08.18l.15,1.07a.08.08,0,0,0,.09.12Zm1.74-1.72a2.82,2.82,0,0,1,1.2-2.64c.81-.47,1.58,0,1.72,1a2.78,2.78,0,0,1-1.2,2.64A1.142,1.142,0,0,1,337.65,266.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67993",
    "data-name": "Path 67993",
    d: "M181,359.34l-.87.5a.14.14,0,0,1-.22-.13l-.74-5.14a.36.36,0,0,1,.16-.35l.87-.5c.1-.06.2,0,.22.13l.74,5.14a.36.36,0,0,1-.16.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67994",
    "data-name": "Path 67994",
    d: "M183.86,357.65l-.86.51c-.11.06-.21,0-.23-.13l-.74-5.14a.41.41,0,0,1,.16-.35l.87-.5a.15.15,0,0,1,.23.12l.73,5.15a.35.35,0,0,1-.16.34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67970",
    "data-name": "Path 67970",
    d: "M345,69.75a1.381,1.381,0,0,0-.12-.34v-.07a1.571,1.571,0,0,0-.15-.32,1.81,1.81,0,0,0-.32-.46.75.75,0,0,0-.17-.19.809.809,0,0,0-.14-.12,1.181,1.181,0,0,0-.32-.23h0a2.661,2.661,0,0,0-.39-.16,3.45,3.45,0,0,0-2.84.43L140.2,183.51c-2.19,1.26-3.71,4.2-3.12,8.3l25.69,179.43c.28,1.94,2.9,3.06,4.72,2L367.68,258a7.08,7.08,0,0,0,3.37-6.54L345.1,70.21C345.08,70.05,345,69.89,345,69.75Z",
    fill: "#455a64",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67971",
    "data-name": "Path 67971",
    d: "M343.35,67.83a3.45,3.45,0,0,0-2.84.43L140.2,183.51a7.09,7.09,0,0,0-3.37,6.54l1,7.13L132,194.65l-1-7a7.07,7.07,0,0,1,3.36-6.53L334.66,65.83a3.36,3.36,0,0,1,3.08-.35C338.57,65.85,342.38,67.45,343.35,67.83Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67972",
    "data-name": "Path 67972",
    d: "M345.09,70.18c-.35-2.32-2.39-3.18-4.58-1.92L140.2,183.51a7.12,7.12,0,0,0-3.37,6.54l1,7.14L346.12,77.36Z",
    fill: "#3d4b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67973",
    "data-name": "Path 67973",
    d: "M340.51,68.26,140.21,183.51a7.1,7.1,0,0,0-2.63,2.85l-5.83-2.48a7,7,0,0,1,2.6-2.81L334.66,65.83a3.36,3.36,0,0,1,3.08-.35c.83.37,4.63,2,5.59,2.34a3.42,3.42,0,0,0-2.82.44Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67974",
    "data-name": "Path 67974",
    d: "M132,194.67l-1-7.06a6.4,6.4,0,0,1,.77-3.73l5.84,2.47a6.2,6.2,0,0,0-.75,3.7l1,7.14Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67975",
    "data-name": "Path 67975",
    d: "M329.29,78.42a3.18,3.18,0,0,0-1.2,3c.17,1.19,1,1.76,1.82,1.28a3.17,3.17,0,0,0,1.2-3C330.94,78.51,330.13,77.94,329.29,78.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67976",
    "data-name": "Path 67976",
    d: "M334.73,75.27a3.19,3.19,0,0,0-1.2,3c.17,1.18,1,1.76,1.82,1.27a3.17,3.17,0,0,0,1.2-3C336.38,75.36,335.57,74.79,334.73,75.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67977",
    "data-name": "Path 67977",
    d: "M340.18,72.13a3.15,3.15,0,0,0-1.21,3c.17,1.19,1,1.76,1.82,1.28a3.18,3.18,0,0,0,1.21-3C341.83,72.21,341,71.64,340.18,72.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67978",
    "data-name": "Path 67978",
    d: "M164.63,373.4l-.24-.1-4.83-2.06a4.54,4.54,0,0,1-2.65-2.75,5.228,5.228,0,0,1-.12-.54L132,194.66l5.87,2.53,24.92,174.05a2.42,2.42,0,0,0,.33.89A3.32,3.32,0,0,0,164.63,373.4Z",
    fill: "#263238",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "play_16421989",
    d: "M0,35.379,64.656,0,73.742,83.91l-60.6,40.274Z",
    transform: "translate(217.375 169.298)",
    fill: "url(#pattern)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e18e5801a6ab5a830ccded7ed790f313.svg";
export { ForwardRef as ReactComponent };